import React, { createContext } from 'react';

export const SellFactorSCLContext = createContext(undefined);